module.exports = __webpack_public_path__ + "static/media/gg-purple.131912eb.svg";